<template>
    <span :class="`country-icon-${size} fi-${countryCode}`" class="fi"></span>
</template>

<script>
export default {
props: {
    countryCode: {
        type: String,
        required: true
    },
    size: {
        type: String,
        default: "small"
    }
}
};
</script>

<style scoped>
.country-icon-small {
width: 1.33rem;
height: 1rem;
}
.country-icon-big {
width: 1.6rem;
height: 1.2rem;
}
</style>